import { writable, get } from "svelte/store";
import { Requirement } from "../models/requirements";
function createStore() {
    // Create and init
    const store = writable(new Requirement());
    const { subscribe, set, update } = store;
    // Return
    return {
        subscribe,
        reset: () => set(new Requirement()),
        getInfos: () => {
            return get(store).info;
        },
        updateInfos: (title, description) => update((n) => {
            return Object.assign(Object.assign({}, n), { info: {
                    title: title,
                    description: description
                } });
        }),
        getStakes: () => {
            return get(store).stakes;
        },
        updateStakes: (stakes) => update((n) => {
            return Object.assign(Object.assign({}, n), { stakes: stakes });
        }),
        getActors: () => {
            return get(store).actors;
        },
        updateActors: (actors) => update((n) => {
            return Object.assign(Object.assign({}, n), { actors: actors });
        }),
        getDatas: () => {
            return get(store).datas;
        },
        updateDatas: (datas) => update((n) => {
            return Object.assign(Object.assign({}, n), { datas: datas });
        }),
        getActions: () => {
            return get(store).actions;
        },
        updateActions: (actions) => update((n) => {
            return Object.assign(Object.assign({}, n), { actions: actions });
        }),
        getQuestions: () => {
            return get(store).questions;
        },
        updateQuestions: (questions) => update((n) => {
            return Object.assign(Object.assign({}, n), { questions: questions });
        })
    };
}
export const RequirementStore = createStore();
